import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { usePushNotification, NotificationTypes } from '../../../actions/notifications';
import { getTimesWarnings } from '../../../selectors/sended-data';
import { useStyles } from '../useStyles';
import { useCurrentLeg } from '../../../selectors/screen';
import { getAllTimeErrorsAsString } from '../../../service/NavPointsUtils';
import { Button } from '../../material-ui/Button';

export const IncorrectButton = ({ name }) => {
    const classes = useStyles();
    const pushNotification = usePushNotification();
    const currentLegID = useCurrentLeg();
    const timeWarnings = useSelector((state) => getTimesWarnings(state))[currentLegID];
    const fields = timeWarnings[name];
    const allTimesWarning = React.useMemo(getAllTimeErrorsAsString(timeWarnings), [timeWarnings]);
    const { t: translate } = useTranslation();

    const handleClick = React.useCallback(() => {
        const notification = {
            variant: NotificationTypes.ERROR,
            message: translate('actionTimeControl.chronologicalBroken'),
            details: translate('actionTimeControl.checkTimeField'),
        };

        if (fields.length) {
            notification.details = `${translate('actionTimeControl.timesIncorect')} ${translate('actionTimeControl.checkTwoField', {
                fieldA: fields[0],
                fieldB: fields[1],
            })}`;
        }

        if (!fields.length && allTimesWarning) {
            notification.details = `${translate('actionTimeControl.timesIncorect')} ${translate('actionTimeControl.checkField', {
                fields: allTimesWarning,
            })}`;
        }

        pushNotification(notification);
    }, [allTimesWarning, fields]);

    return (
        <span className={classes.incorrectButton}>
            <span className={classes.textIncorrect}>Some of the entered times are incorrect</span>
            <Button variant="contained" color="primary" className={classes.button} onClick={handleClick}>
                {translate('actionTimeControl.details')}
            </Button>
        </span>
    );
};
